import request, { Methods, withToken } from "../../../utils/request";
import { getUserCompany } from "../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_PERSONNEL_ACTIONS_DEFAULT = "POST_PERSONNEL_ACTIONS_DEFAULT";
export const POST_PERSONNEL_ACTIONS_REQUEST = "POST_PERSONNEL_ACTIONS_REQUEST";
export const POST_PERSONNEL_ACTIONS_SUCCESS = "POST_PERSONNEL_ACTIONS_SUCCESS";
export const POST_PERSONNEL_ACTIONS_ERROR = "POST_PERSONNEL_ACTIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const postPersonnelActionsDefault = () => ({
  type: POST_PERSONNEL_ACTIONS_DEFAULT,
});

export const postPersonnelActionsRequest = (payload = {}, callback) => ({
  type: POST_PERSONNEL_ACTIONS_REQUEST,
  payload,
  callback,
});

export const postPersonnelActionsSuccess = (data) => ({
  type: POST_PERSONNEL_ACTIONS_SUCCESS,
  payload: data,
});

export const postPersonnelActionsError = (error) => ({
  type: POST_PERSONNEL_ACTIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postPersonnelActionsServiceRequest = async (formData) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data: formData
  });
  return request(`/personnel_actions`, options);
};
